export default "__VITE_ASSET__BR_Y8MeT__"